<template>
  <div>
    <b-tooltip
      position="is-left"
      :label="$t('insight.print')"
    >
      <div @click="modalImpression = true">
        <img
          style="margin-top:3px;width:20px; height:20px;cursor:pointer;"
          src="~@/assets/img/icons/print-icon.png"
          alt="print-icon"
        />
      </div>
    </b-tooltip>
    <!-- modal pour l'impression -->
    <b-modal :active.sync="modalImpression" :width="480">
      <AdminResultatsIndividuelsPopupImpression />
    </b-modal>
  </div>
</template>

<script>
import AdminResultatsIndividuelsPopupImpression from "@/components/popup/AdminResultatsIndividuelsPopupImpression";

export default {
  components: {
    AdminResultatsIndividuelsPopupImpression,
  },
  data() {
    return {
      windowWidth: window.windowWidth,
      modalImpression: false,
    };
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
};
</script>

<style></style>
